var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8072 8.48498L16.5222 14.2272C17.1593 14.862 17.1593 15.89 16.5222 16.5239C16.2162 16.8284 15.802 16.9992 15.3704 16.9992C14.9387 16.9992 14.5246 16.8284 14.2185 16.5239L8.48496 10.8073M10.8072 8.48498L7.71089 5.38861M10.8072 8.48498L11.1942 8.8721L12.9692 7.09711C13.1143 6.95194 13.1958 6.75508 13.1958 6.54982C13.1958 6.34456 13.1143 6.1477 12.9692 6.00254L10.1933 3.22664C10.0482 3.08152 9.85131 3 9.64606 3C9.4408 3 9.24394 3.08152 9.09878 3.22664L7.32383 5.00164L7.71089 5.38861M10.8072 8.48498L8.48496 10.8073M8.48496 10.8073L5.38866 7.71089M8.48496 10.8073L8.87198 11.1944L7.09702 12.9694C6.95186 13.1145 6.75501 13.196 6.54975 13.196C6.34449 13.196 6.14764 13.1145 6.00248 12.9694L3.22664 10.1935C3.08152 10.0483 3 9.85145 3 9.64619C3 9.44093 3.08152 9.24407 3.22664 9.09891L5.0016 7.32392L5.38866 7.71089M5.38866 7.71089L7.71089 5.38861M3.06643 17H8.48496",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPolicyIcon);
export default __webpack_public_path__ + "static/media/menu-policy-icon.c67e30af8c82188f074cc1167266b80f.svg";
export { ForwardRef as ReactComponent };